import { Box } from "@mui/material";

const manualUrl = `${process.env.PUBLIC_URL}/manual_administrador`;

const HelpManualScreen = () => {
  return (
    <Box sx={{ height: "calc(100vh - 140px)", minHeight: 600 }}>
      <iframe
        title="Manual del administrador"
        src={manualUrl}
        style={{
          width: "100%",
          height: "100%",
          border: 0,
          borderRadius: 12,
          backgroundColor: "#ffffff",
        }}
      />
    </Box>
  );
};

export default HelpManualScreen;